import React, {
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
  useState
} from "react";

type ExpandableFareCardContextValue = {
  isExpanded: boolean;
  onToggleFareCardExpandClick: () => void;
};

const ExpandableFareCardContext =
  React.createContext<ExpandableFareCardContextValue>({
    isExpanded: false,
    onToggleFareCardExpandClick: () => {
      ///
    }
  });

export const ExpandableFareCardProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const onToggleFareCardExpandClick = useCallback(() => {
    setIsExpanded((currentValue) => !currentValue);
  }, []);

  const contextValue = useMemo(() => {
    return {
      isExpanded,
      onToggleFareCardExpandClick
    };
  }, [isExpanded, onToggleFareCardExpandClick]);

  return (
    <ExpandableFareCardContext.Provider value={contextValue}>
      {children}
    </ExpandableFareCardContext.Provider>
  );
};

export const useExpandableFareCard = () => {
  return useContext(ExpandableFareCardContext);
};
